import moment from "moment";
import React from "react";
import {CustomButton} from "./WalletStartDateButton.styles";
export const WalletStartDateButton = ({walletStartDate, handleClick}) => {
    return (
        <CustomButton onClick={handleClick}>
            <span id="status-label">
                Cüzdan Oluşturulma Tarihi : {moment(walletStartDate).format("DD/MM/YYYY")}
            </span>
            <span id="action-label">
                Cüzdan Oluşturulma Tarihi :{" "}
                <b>{moment(walletStartDate).format("DD/MM/YYYY")} itibaren filtrele</b>
            </span>
        </CustomButton>
    );
};
